angular.module('mercury.modules.settings.support')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Settings.SupportInvites', {
    url: '/supportinvites/:id',
    controller: 'SupportInvitesCtrl',
    templateUrl: 'modules/settings/support/supportinvites.tpl.html'
  });
}]);
